/*jslint browser */
/*global process */

var $ = jQuery;
declare var xtAjaxurl: string;

/**
 *
 */
export default class ProductQuestionController
{
    private _sendQuestion: JQuery;
    private _userEmail: JQuery;
    private _userName: JQuery;
    private _userPhone: JQuery;
    private _productQuestion: JQuery;
    private _productId: JQuery;
    private _questionModal: JQuery;
    private _questionTermCondition: JQuery;

    constructor()
    {

    }

    public questionAction(): void
    {
        this.registerEvents();
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._sendQuestion = $('.send-question');
        this._userEmail = $('.user-email');
        this._userName = $('.user-name');
        this._userPhone = $('.user-phone');
        this._productQuestion = $('.product-question');
        this._productId = $('.product-id');
        this._questionTermCondition = $('.question-term-condition');
        this._questionModal = $('#questionModal');

        this._sendQuestion.on('click', (e) => {
            this.sendQuestion();
        })
    }

    private sendQuestion() :void
    {
        let validation = true;

        this._userEmail.removeClass('question-field-error');
        this._productQuestion.removeClass('question-field-error');
        this._questionTermCondition.removeClass('question-field-error');

        if(this._userEmail.val() == '' || !this.validateEmail(this._userEmail.val() as string)) {
            this._userEmail.addClass('question-field-error');
            validation = false;
        }

        if(this._productQuestion.val() == '') {
            this._productQuestion.addClass('question-field-error');
            validation = false;
        }

        if(!this._questionTermCondition.is(':checked')) {
            this._questionTermCondition.addClass('question-field-error');
            validation = false;
        }

        if(validation) {
            const text = this._sendQuestion.text();
            this._sendQuestion.text('Wysyłanie');
            this._sendQuestion.prop('disabled', true);

            const ajaxData = {
                'action': 'main_ajax',
                'controller': 'AjaxController',
                'run': 'sendQuestion',
                'productId': this._productId.val(),
                'userEmail': this._userEmail.val(),
                'userName': this._userName.val(),
                'userPhone': this._userPhone.val(),
                'productQuestion': this._productQuestion.val()
            }

            const ob = this;

            $.post(xtAjaxurl, ajaxData, function (response) {
                if(response.status == 'success') {
                    // @ts-ignore
                    ob._questionModal.modal('hide');
                    ob._sendQuestion.text(text);
                    ob._sendQuestion.prop('disabled', false);
                    ob._userEmail.val('');
                    ob._userName.val('');
                    ob._userPhone.val('');
                    ob._productQuestion.val('');
                    setTimeout(function(){
                        // @ts-ignore
                        alert('Zapytanie wysłane!');
                    }, 1000);
                } else {
                    ob._sendQuestion.text(text);
                    ob._sendQuestion.prop('disabled', false);
                    // @ts-ignore
                    alert('Coś poszło nie tak! Spróbuj ponownie za jakiś czas.');
                }
            });

        }
    }

    private validateEmail(email: string) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
}